import React, {useEffect, useState} from 'react';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";
import {useApi} from "../../providers/ApiProvider";
import {useTranslation} from "react-i18next";
import {useTranslation as useMyTranslation} from "../../providers/TranslationProvider";

function ForgotPassword(props) {
    const {language} = useMyTranslation();
    const { t} = useTranslation();
    const apiContext = useApi();

    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);


    const handleSubmit = (e) => {
        e.preventDefault();

        if (email === '') {
            setError(t('Please, enter your email.'));
            return;
        }

        const credentials = {
            email: email
        }

        apiContext.api.authForgotPassword(credentials).then((response) => {
            if (response === false) {
                setError(t('Something went wrong.'));
            } else {
                setSuccess(true);
            }
        });
    }


    useEffect(() => {
        document.title = t('Reset your password')+' | LocalBoost';
    }, [language]);


    return (
        <>
            <div className="text-center">
                <h4 className="mb-0">{t('Forgot your password?')}</h4>

                {success && (
                    <div className="alert alert-primary mt-4" role="alert">{t('Please, check your email for further instructions.')}</div>
                ) || !success && (<>
                    <small>{t('Enter your email and we\'ll send you a reset link.')}</small>

                    {error !== '' && <div className="alert alert-danger mt-4" role="alert">{error}</div>}

                    <form className="mb-3 mt-4">
                        <input className="form-control" type="email" placeholder={t('Email address')} value={email} onChange={(e) => setEmail(e.target.value)} />
                        <div className="mb-3"></div>
                        <button className="btn btn-primary d-block w-100 mt-3" type="submit" name="submit" onClick={handleSubmit}>{t('Send reset link')}</button>
                    </form>
                </>)}

                <Link className="fs--1 text-600" to="/auth/login"><span className="d-inline-block me-1">&larr;</span> {t('Go back to login page')}</Link>
            </div>
        </>
    );
}

export default ForgotPassword;
